const DeleteSelectionButton = ({title, collections, deleteSelection}) =>  (
    <button className="button icon button-delete button-delete-selection" onClick={() => deleteSelection(collections)}>
        <span className="screen-reader-text">{title}</span>
    </button>
)

export default DeleteSelectionButton